import type { PropsWithChildren } from "react";
import { RouterProvider } from "react-aria-components";
import { useNavigate } from "react-router-dom";

export const RouteProvider = ({ children }: PropsWithChildren) => {
	const navigate = useNavigate();

	return (
		<RouterProvider
			navigate={(to) => {
				const path = typeof to === "string" ? to : "/";
				navigate(path, { replace: false });
				window.scrollTo(0, 0);
			}}
		>
			{children}
		</RouterProvider>
	);
};
